<core-spinner *ngIf="vm.isLoading"></core-spinner>

<div class="container-fluid" *ngIf="!vm.isOpening">

  <form>
    <cli-landing-header></cli-landing-header>


    <div class="row mt-3">
      <div class="col-xl-2 col-lg-1 "></div>
      <div class="col-xl-2 col-lg-2 col-md-3  pt-2">
        <cli-landing-menu></cli-landing-menu>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-5 ">
        <div class="mt-2 row">
          <div class="col welcome-text text-center">Activate Hydrotrak Account</div>
        </div>

        <div class="row">
          <div class="col d-flex justify-content-center">
            <div style="width:300px;">

              <div *ngIf="vm.exists && vm.isActivated && !vm.isPasswordSet">
                <div class="alert alert-success" *ngIf="!vm.isNoEmail">
                  Email address successfully validated
                </div>

                <div class="mb-2">
                  <label>
                    Username *
                  </label>
                  <input class="form-control" [ngClass]="{'is-invalid': !!error('userName')}" name="userName"
                    placeholder="Email Address" type="email" [(ngModel)]="vm.userName" [readonly]="true">
                  <div class="invalid-feedback">
                    {{error('userName')}}
                  </div>
                </div>
                <div class="mb-2">
                  <label>
                    Password *
                  </label>
                  <input class="form-control" [ngClass]="{'is-invalid': !!error('password')}" name="password"
                    placeholder="Password" type="password" [(ngModel)]="vm.password">
                  <div class="invalid-feedback">
                    {{error('password')}}
                  </div>
                </div>
                <div class="mb-2">
                  <input class="form-control" [ngClass]="{'is-invalid': !!error('confirmPassword')}"
                    name="confirmPassword" placeholder="Confirm Password" type="password"
                    [(ngModel)]="vm.confirmPassword">
                  <div class="invalid-feedback">
                    {{error('confirmPassword')}}
                  </div>
                </div>

                <div class="row">
                  <div class="col"></div>
                  <div class="col-md-6 mt-4">
                    <button class="btn btn-block btn-primary" (click)="activateAccount()">Activate</button>
                  </div>
                  <div class="col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="vm.exists && (!vm.isActivated || !vm.isPasswordSet)" class="text-center mt-5 mb-5">          
            Please create password to activate your Hydrotrak account          
        </div>

        <div *ngIf="!vm.exists" class="alert alert-danger text-center mt-5 mb-5">
          Sorry we cannot recognise this Hydrotrak link
        </div>

        <div *ngIf="vm.exists && vm.isActivated && vm.isPasswordSet" class="alert alert-success mt-5 mb-5">
          Thank you for activating your Hydrotrak account
          Please click the link to <a [routerLink]="['/login']">log in</a>.
        </div>


      </div>
      <div class="col-xl-2 col-lg-2 col-md-3"></div>
      <div class="col-xl-2 col-lg-1 "></div>
    </div>

    <cli-landing-footer></cli-landing-footer>
  </form>
</div>